export const MATCH_THRESHOLD_MS = 80; // Debounce for microphone pitch detection

export const TIMINGS = {
  PROCESSING_LOCKOUT_MS: 150,
  EXIT_ANIMATION_CLEANUP_MS: 600,
  CHALLENGE_COMPLETE_DELAY_MS: 1500,
} as const;
